import React from 'react';

const LoadingSpinner = ({ fullPage = false, size = 'medium', color = 'blue' }) => {
  const sizeClasses = {
    small: 'tw-w-6 tw-h-6 tw-border-2',
    medium: 'tw-w-8 tw-h-8 tw-border-4',
    large: 'tw-w-12 tw-h-12 tw-border-4'
  };

  const colorClasses = {
    blue: 'tw-border-blue-500 tw-border-t-transparent',
    white: 'tw-border-white tw-border-t-transparent',
    gray: 'tw-border-gray-400 tw-border-t-transparent'
  };

  const spinner = (
    <div className={`tw-inline-block ${sizeClasses[size]} ${colorClasses[color]} tw-rounded-full tw-animate-spin`}>
      <span className="tw-sr-only">Loading...</span>
    </div>
  );

  if (fullPage) {
    return (
      <div className="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-white tw-bg-opacity-75 tw-z-50">
        {spinner}
      </div>
    );
  }

  return spinner;
};

export default LoadingSpinner;